module.exports = __webpack_public_path__ + "img/rf_advanced_1.a70704c6.jpg";